module.exports = __webpack_public_path__ + "img/ic_save.7e9cbaf4.png";